///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/select2.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'


declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/TimesheetReport/timesheetReport.html'
})

export class TimesheetReportComponent implements OnInit {
    constants: Constants;
    projectList: any = [];
    timesheetItems: any = [];
    siteUserItems: any = [];
    userDetail: any;
    userList: any = [];
    teamList: any = [];
    taskgroupList: any = [];
    taskTypeList: any = [];
    taskTypeSortList: any = [];
    NewtaskTypeSortList: any = [];
    displayData: any = [];
    UpdateList: any = [];
    // projectidList:any =[];
    objSiteUserItem: any = [];
    newTaskGroupList: any = [];
    selfuser: boolean = true;
    public showLoader = false;

    filter: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'), 'TaskType_Id': "", 'TaskGroup_Id': "", 'TeamId': "", 'UserId': "" };

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //  this.filter={'TeamId': this.timesheetItems.TeamID, 'UserId': this.timesheetItems.SiteUserId}
        this.filter.TeamId = "";
    }

    ngOnInit() {

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        this.filter.FromDate = newDate;

        // this.GetProjectList(val);
       // this.GetUserList();
        this.GetUserListbyproj();
        this.GetTimesheet(true);
        this.GetteamList();
        this.changeUserId(0);
        this.changeProjectId(0);
        this.GetProjectList(0);
        this.changeTaskTypeById("");

        //   this.GettaskGroupList();
        // this.GettaskTypeList();
    }

    ExportItems() {
        ExportToExcel(this.timesheetItems, "Timesheet Details",
            ["name", "Team_Id","TimeSheet_Date", "Project_Title","ProjectType","OwnerTeam", "TaskTypeName","TaskId", "Comments", "TimeSpent"],
            ["Name", "Team Name","Date", "Project","Project Type","Project Owner", "Task Type","Task Id", "Comments", "Time Spent (mins)"]);
    }

    ngAfterViewInit() {


        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

        $('#projectIdFilter').select2().val("").trigger("change");
        $('#projectIdFilter').on(
            'change',
            (e) => {
                this.filter.ProjectId = $(e.target).val();
                this.changeProjectId(this.filter.ProjectId)
            }
        );

        $('#userIdFilter').select2().val("").trigger("change");
        $('#userIdFilter').on(
            'change',
            (e) => this.filter.UserId = jQuery(e.target).val()
        );

        $('#taskTypeIdFilter').select2().val("").trigger("change");
        $('#taskTypeIdFilter').on(
            'change',
            (e) => this.filter.TaskType_Id = jQuery(e.target).val()
        );

    }

    ngAfterViewChecked() {
    }

    changeTeamId(val) {
        if (val == "")
        { }
        else {
            this.objSiteUserItem = [];
            this.objSiteUserItem = this.siteUserItems.filter((item) => item.Site_UserId == val);
            if (this.objSiteUserItem.length > 0) {
                this.filter.TeamId = this.objSiteUserItem[0].TeamID;
            }
            else {
                this.filter.TeamId = "";
            }
        }
    }


    changeUserId(val) {
        console.log(this.filter.TeamId);
        console.log(this.userList);
        if (val == "")
        { }
        else {
            this.objSiteUserItem = [];
            this.objSiteUserItem = this.siteUserItems.filter((item) => item.TeamID == val);
            if (this.objSiteUserItem.length > 0) {
                this.filter.UserId = this.objSiteUserItem[0].Site_UserId;
            }
            else {
                this.filter.UserId = "";
            }
            // this.filter.UserId= this.userList.filter((item) => item.TeamID == val)[0].SiteUser_Id;
        }

    }

    changeProjectId(val) {
        this.showLoader = true;
        this.filter.TaskGroup_Id = "";
        if (val == "" || val == null) {
            this._httpService.ajaxPost("Project/GetProjectById",
                { "ProjectId": 0 }).subscribe(
                data => {
                    this.taskgroupList = data["ProjectList"];
                },
                err => {
                    this.showLoader = false;

                },
                () => {
                    this.showLoader = false;
                })
            this.filter.TaskGroupId = "";
        }
        else {
            this._httpService.ajaxPost("Project/GetProjectById",
                { "ProjectId": val }).subscribe(
                data => {
                    this.taskgroupList = data["ProjectList"];
                    this.newTaskGroupList = this.taskgroupList;
                    if (val == "")
                    { }
                    else {
                        if (this.taskgroupList.filter((item) => item.Project_Id == val).length != 0) {
                            this.filter.TaskGroupId = this.taskgroupList.filter((item) => item.Project_Id == val)[0].TaskGroupId;
                        }
                    }
                    // setTimeout(function () {
                    //     $(".project").selectpicker('refresh');
                    // }, 1000);
                },
                err => {
                    console.log("GetProjectidList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
                );
        }

        this.changeTaskTypeId(val);
    }

    changeTaskTypeId(val) {
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetTasktypeById",
            { "ProjectId": val }).subscribe(
            data => {
                this.taskTypeSortList = data["ProjectList"];
            },

            err => {
                console.log("GetProjectidList Failed");
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }

            );
    }

    changeTaskTypeById(val) {
        this.showLoader = true;
        this.filter.TaskType_Id = ""
        if (val == "" || val == null) {
            this._httpService.ajaxPost("Project/GetTasktypeByTaskGroup",
                { "TaskGroupId": val }).subscribe(
                data => {
                    this.NewtaskTypeSortList = data["ProjectList"];
                    this.UpdateList = this.NewtaskTypeSortList;
                },
                err => {
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                })
        } else {
            this._httpService.ajaxPost("Project/GetTasktypeByTaskGroup",
                { "TaskGroupId": val }).subscribe(
                data => {
                    this.NewtaskTypeSortList = data["ProjectList"];
                    this.UpdateList = this.NewtaskTypeSortList;
                    // JSON.parse(JSON.stringify(this.NewtaskTypeSortList.filter((item) => item.TaskGroupId == this.filter.TaskGroup_Id)));
                },
                err => {
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                })


        }
    }

    public clearFilter() {
        this.filter = { 'ProjectId': "", 'TaskType_Id': "", 'UserId': "", 'TeamId': "", 'TaskGroup_Id': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY') };
        this.filter.TeamId = "";

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        this.filter.FromDate = newDate;

        $('#projectIdFilter').select2().val("").trigger("change");
        $('#userIdFilter').select2().val("").trigger("change");
        $('#taskTypeIdFilter').select2().val("").trigger("change");
        this.changeTaskTypeById("");
    }


    GetProjectList(val) {
        this.filter.ProjectId = "";
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0 && val == "") {
            UserId = this.userDetail.SiteUserId;
            TeamId = this.userDetail.TeamID;
        }
        else {
            UserId = val;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetProjectByuser",
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 1, "UserId": UserId }).subscribe(
            data => {
                this.projectList = data["ProjectList"];
            },
            err => {
                console.log("GetProjectList Failed");
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
            );
    }

      GetUserList() {
          console.log("wwwwwwwwwwww");
          //   this.filter.UserId="";
         this.showLoader = true;
         this._httpService.ajaxPost("Users/GetUsers",
              {
                 "IsActive": this.constants.enumUserStatus["Active"],
                  "Role": null,
                 "Site": null,
                  "Team": this.userDetail.TeamID,
                 "UserId": this.userDetail.SiteUserId
             }).subscribe(
             data => {
                 this.userList = data["Users"];
                $(".project").val('').selectpicker('refresh');
           },
           err => {
                 console.log("GetUserList Failed");
               this.showLoader = false;
            },
           () => {
                  this.showLoader = false;
              }
             );
      }
 
	
        
 GetUserListbyproj() {
        //   this.filter.UserId="";
        var teamId= this.userDetail.TeamID;
        
        this.showLoader = true;
        this._httpService.ajaxPost("TimeSheet/GetUsersByProject",
            {   "Project_Id": 0,
                "IsActive": this.constants.enumUserStatus["Active"],
                "Team_Id":teamId,
                "ProjectType": 0,
                "Status": 1,
                "UserId": this.userDetail.SiteUserId
            }).subscribe(
            data => {
                this.userList = data["Users"];
                $(".project").val('').selectpicker('refresh');
            },
            err => {
                console.log("GetUserList Failed");
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
            );
    }

    GetteamList() {
        // this.filter.UserId="";
        this.showLoader = true;
        //   this.filter.UserId="";
        this._httpService.ajaxPost("Team/GetAssignedTeam", { "TeamId": this.userDetail.TeamID, "UserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.teamList = data["AssignedTeam"];
            },
            err => {
                console.log("GetTeamList Failed");
                this.showLoader = false;
            },
            () => {
                this.GetUserListbyproj();
                this.showLoader = false;
            }
        );
    }


    compare(a, b) {
        if (a.TaskTypeName < b.TaskTypeName)
            return -1;
        if (a.TaskTypeName > b.TaskTypeName)
            return 1;
        return 0;
    }


    GetTimesheet(flag: boolean) {
        this.showLoader = true;
        this.selfuser = flag;
        var UserId = 0
        if (this.filter.UserId == "") {
            //UserId = this.userDetail.SiteUserId
        }
        else {
            UserId = this.filter.UserId
        }
        var TeamId = "0"
        if (this.filter.TeamId == "") {
            //TeamId = this.userDetail.TeamID
            TeamId = this.constants.TeamId;
        }
        else {
            TeamId = this.filter.TeamId
        }
        this._httpService.ajaxPost("Timesheet/GetTimesheet",
            {
                "TimesheetId": 0,
                "UserId": UserId,
                "ProjectId": this.filter.ProjectId,
                "FromDate": this.filter.FromDate,
                "ToDate": this.filter.ToDate,
                "TaskTypeId": this.filter.TaskType_Id,
                "TaskGroupId": this.filter.TaskGroup_Id,
                "TeamId": TeamId,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(
            data => {
                this.timesheetItems = data["TimesheetList"];
                // this.timesheetItems.forEach(element => {
                //     element.TimeSheet_Date = this.datePipe.transform(element.TimeSheet_Date, "dd-MM-yyyy");
                // });
            },
            err => {
                console.log("GetTimesheetList Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                this._httpService.ajaxPost("Common/GetSiteUser").subscribe(
                    data => {
                        this.siteUserItems = data["SiteUser"];
                    },
                    err => {
                        this.showLoader = false
                    },
                    () => {
                        this.showLoader = false;
                    });
                this.showLoader = false;
            });
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/TimesheetReport/timesheetReport.component.ts
 **/